import { useMutation, useQueryClient } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import { cancelCreditsSubscription } from '@pray/shared/services/studioService/credits';

type UseCancelSubscriptionProps = {
  artistId: string;
};

type CancelSubscriptionVariables = {
  subscriptionId: string;
};

export function useCancelSubscription({ artistId }: UseCancelSubscriptionProps) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ subscriptionId }: CancelSubscriptionVariables) => {
      await cancelCreditsSubscription({ artistId, subscriptionId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.artistCreditAccount(artistId),
      });
    },
  });

  return mutation;
}
